"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.InlineResponse20012SummaryToJSON = exports.InlineResponse20012SummaryFromJSONTyped = exports.InlineResponse20012SummaryFromJSON = void 0;
var runtime_1 = require("../runtime");
function InlineResponse20012SummaryFromJSON(json) {
    return InlineResponse20012SummaryFromJSONTyped(json, false);
}
exports.InlineResponse20012SummaryFromJSON = InlineResponse20012SummaryFromJSON;
function InlineResponse20012SummaryFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'totalGames': !(0, runtime_1.exists)(json, 'totalGames') ? undefined : json['totalGames'],
        'totalQuests': !(0, runtime_1.exists)(json, 'totalQuests') ? undefined : json['totalQuests'],
        'gamesWithProgress': !(0, runtime_1.exists)(json, 'gamesWithProgress') ? undefined : json['gamesWithProgress'],
    };
}
exports.InlineResponse20012SummaryFromJSONTyped = InlineResponse20012SummaryFromJSONTyped;
function InlineResponse20012SummaryToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'totalGames': value.totalGames,
        'totalQuests': value.totalQuests,
        'gamesWithProgress': value.gamesWithProgress,
    };
}
exports.InlineResponse20012SummaryToJSON = InlineResponse20012SummaryToJSON;
